import { useLang } from "../i18n/LanguageContext";

const TABLE_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/9e1313c0-9298-432e-9d95-61137a646d40/images/41115e869dff2a318889e4c893d7300946b7f12456d8ce81b76039675593712c.png";

export const DiningModel = () => {
  const { t } = useLang();

  return (
    <section
      id="table"
      data-testid="table-section"
      className="relative py-24 md:py-32 bg-[#f2ebe1]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-center">
          {/* Image left */}
          <div className="col-span-12 md:col-span-7 order-2 md:order-1">
            <div className="zoom-frame rounded-sm overflow-hidden border border-[#e5d9c5]">
              <img
                src={TABLE_IMAGE}
                alt="Private dining table set for six"
                className="w-full h-[420px] md:h-[560px] object-cover"
                data-testid="table-image"
              />
            </div>
          </div>

          {/* Text right */}
          <div className="col-span-12 md:col-span-5 order-1 md:order-2">
            <div className="flex items-center gap-3 mb-6">
              <span className="editorial-divider" />
              <span className="overline" data-testid="table-overline">
                {t.table.overline}
              </span>
            </div>
            <h2
              data-testid="table-title"
              className="font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#2c1e16] mb-8"
            >
              {t.table.title}
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-[#2c1e16]/75 mb-10">
              {t.table.copy}
            </p>

            <dl className="grid grid-cols-2 gap-y-6 gap-x-8 border-t border-[#e5d9c5] pt-8">
              {t.table.facts.map((f, i) => (
                <div key={i} data-testid={`fact-${i}`}>
                  <dt className="font-mono-utility text-[10px] tracking-[0.25em] uppercase text-[#5b664f] mb-1.5">
                    {f.label}
                  </dt>
                  <dd className="font-serif-display text-2xl text-[#2c1e16]">
                    {f.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
};
